import React from "react";
import { CASE_STUDIES } from "../lib/data";
import { ArrowUpRight } from "lucide-react";
import DemoRequest from "../components/sections/DemoRequest";

export default function CaseStudies() {
  return (
    <div data-testid="case-studies-page">
      <section className="py-24 sm:py-32 border-b border-zinc-200">
        <div className="container-oj">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">Case studies</div>
          <h1 className="font-display mt-4 text-5xl sm:text-7xl font-black tracking-tighter leading-[0.92] text-oj-ink max-w-3xl">
            Operators who picked the platform, then beat their numbers.
          </h1>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-zinc-50">
        <div className="container-oj grid grid-cols-1 md:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c) => (
            <article
              key={c.slug}
              data-testid={`case-${c.slug}`}
              className="rounded-2xl bg-white border border-zinc-200 p-8 hover:border-zinc-900 transition-colors group"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">/{c.slug}</span>
                <ArrowUpRight className="size-4 text-zinc-500 group-hover:text-oj-ink" />
              </div>
              <div className="mt-8 font-display text-3xl font-black tracking-tighter" style={{ color: c.color }}>
                {c.metric}
              </div>
              <h3 className="mt-3 font-display text-xl font-bold text-oj-ink">{c.headline}</h3>
              <div className="mt-2 text-sm font-semibold text-zinc-700">{c.brand}</div>
              <p className="mt-4 text-zinc-600 text-sm leading-relaxed">{c.summary}</p>
            </article>
          ))}
        </div>
      </section>
      <DemoRequest />
    </div>
  );
}
